import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from '@angular/core';
import {
    AsyncValidatorFn,
    FormArray,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import {
    ButtonConfig,
    InputFormStructure,
    InputFormValue,
} from './../shared.interface';

@Component({
    selector: 'app-form-input-group',
    templateUrl: './form-input-group.component.html',
    styleUrls: ['./form-input-group.component.scss'],
})
export class FormInputGroupComponent implements OnInit, OnChanges {
    @Input() formTitle: string;
    @Input() formSubtitle: string;
    @Input() inputArray: InputFormStructure[];
    @Output() onFormSubmit = new EventEmitter<InputFormValue[]>();
    inputForm: FormGroup;
    submitButtonConfig: ButtonConfig;

    constructor() {}

    ngOnInit(): void {
        this.initSubmitButton();
    }

    ngOnChanges() {
        this.initForm();
    }

    initForm(): void {
        const afmInputs = new FormArray([]);
        this.inputArray.forEach((item) => {
            afmInputs.push(
                new FormGroup({
                    afmInput: new FormControl(
                        { value: item.value, disabled: item.submitted },
                        this.getValidators(item),
                        this.getAsyncValidators(item)
                    ),
                    representativeAfm: new FormControl(
                        { value: item.representativeAfm, disabled: item.submitted },
                    ),
                    representativeAfm2: new FormControl(
                        { value: item.representativeAfm2, disabled: item.submitted },
                    ),
                    representativeEmail: new FormControl(
                        { value: item.representativeEmail, disabled: item.submitted },
                    ),
                    individual: new FormControl(
                        { value: item.individual, disabled: item.submitted },
                    ),
                    underage: new FormControl(
                        { value: item.underage, disabled: item.submitted },
                    ),
                })
            );
        });

        if (afmInputs.length === 0) {
            const item = {
                required: true,
                submitted: false,
                individual: true,
                underage: false,
                type: 'afm-input',
                value: '',
                representativeAfm: '',
                representativeAfm2: '',
                representativeError: 0,
                representativeEmail: '',
            };

            afmInputs.push(
                new FormGroup({
                    afmInput: new FormControl(
                        { value: item.value, disabled: item.submitted || !item.individual },
                        this.getValidators(item),
                        this.getAsyncValidators(item)
                    ),
                    representativeAfm: new FormControl(
                        { value: item.representativeAfm, disabled: item.submitted },
                    ),
                    representativeAfm2: new FormControl(
                        { value: item.representativeAfm2, disabled: item.submitted },
                    ),
                    representativeEmail: new FormControl(
                        { value: item.representativeEmail, disabled: item.submitted },
                    ),
                    individual: new FormControl(
                        { value: item.individual, disabled: item.submitted },
                    ),
                    underage: new FormControl(
                        { value: item.underage, disabled: item.submitted },
                    ),
                })
            );
        }

        this.inputForm = new FormGroup({
            afmInputs,
        });
    }

    initSubmitButton(): void {
        this.submitButtonConfig = {
            actionCallback: () => {},
            label: 'Προσθήκη ΑΦΜ',
        };
    }

    getValidators(inputFormStructure: InputFormStructure): Validators {
        const validators = [];
        if (inputFormStructure.required) {
            validators.push(Validators.required);
            validators.push(Validators.pattern(/^[0-9]+[0-9]*$/));
            validators.push(Validators.maxLength(9));
            validators.push(Validators.minLength(9));
            // validators.push(this.duplicateValue.bind(this));
        }
        return Validators.compose(validators);
    }

    getAsyncValidators(
        inputFormStructure: InputFormStructure
    ): AsyncValidatorFn {
        return null;
    }

    // getInputDisabled(index: number): boolean {
    //     if (index > this.inputArray.length - 1) {
    //         return false;
    //     }
    //     return this.inputArray[index].submitted;
    // }

    onAddAfmInput(): void {
        const inputItem: InputFormStructure = {
            value: null,
            representativeAfm: null,
            representativeAfm2: null,
            representativeError: 0,
            representativeEmail: null,
            individual: true,
            underage: false,
            required: true,
            type: 'afm-input',
            submitted: false,
        };

        const afmInput = new FormGroup({
            afmInput: new FormControl(
                { value: inputItem.value, disabled: inputItem.submitted },
                this.getValidators(inputItem),
                this.getAsyncValidators(inputItem)
            ),
            representativeAfm: new FormControl(
                { value: inputItem.representativeAfm, disabled: inputItem.submitted },
            ),
            representativeAfm2: new FormControl(
                { value: inputItem.representativeAfm2, disabled: inputItem.submitted },
            ),
            representativeEmail: new FormControl(
                { value: inputItem.representativeEmail, disabled: inputItem.submitted },
            ),
            individual: new FormControl(
                { value: inputItem.individual },
            ),
            underage: new FormControl(
                { value: inputItem.underage },
            ),
        });
        this.formArray.push(afmInput);
    }

    onDeleteAfmInput(index: number): void {
        this.formArray.removeAt(index);
    }

    onSubmit(): void {
        this.onFormSubmit.emit(this.inputForm.value.afmInputs);
    }

    inputDisabled(index: number): boolean {
        return this.formArray.controls[index].status === 'DISABLED';
    }

    isCompany(index: number){
        return this.formArray.controls[index].get('individual')?.value === false;
    }

    isUnderage(index: number){
      // console.log(this.formArray.controls[index]);
        return this.formArray.controls[index].get('underage')?.value === true;
    }

    // disableInputFields(afms: string[]): void {
    //     afms.forEach((afm) => this.disableInputField(afm));
    //     this.initForm();
    // }

    // disableInputField(afm: string): void {
    //     const inputElement = this.inputArray.find((item) => item.value === afm);
    //     if (inputElement) {
    //         return;
    //     }
    //     this.inputArray.push({
    //         required: true,
    //         submitted: true,
    //         type: 'afm-input',
    //         value: afm,
    //     });
    // }

    duplicateValue(control: FormControl): { [s: string]: boolean } {
        const inputElement = this.inputArray.find(
            (item) => item.value === control.value
        );
        if (inputElement) {
            return { afmExists: true };
        }

        const items = this.inputForm?.value?.afmInputs.filter(
            (item) => item.afmInput === control.value
        );

        if (items && items.length > 0) {
            return { afmExists: true };
        }
        return null;
    }

    get formArray(): FormArray {
        return this.inputForm.get('afmInputs') as FormArray;
    }
}
